import { Select } from '@mantine/core';

interface Option {
  value: string;
  label: string;
}

interface Props {
  value: string;
  options: Option[];
  onChange: (val: string | null) => void;
}

export function DropDown({ value, options, onChange }: Props) {
  return (
    <Select
      mt="md"
      placeholder="Select answer"
      data={options}
      value={value}
      onChange={onChange}
      radius="md"
      size="md"
      comboboxProps={{ zIndex: 1000 }}
    />
  );
}
